export type StepKey = "plans" | "collateral" | "contract" | "schedule";

const LABELS: Record<StepKey, string> = {
  plans: "Seu plano",
  collateral: "Caução",
  contract: "Contrato",
  schedule: "Agendamento",
};

export function Stepper({ steps, current }: { steps: StepKey[]; current: StepKey }) {
  const idx = steps.indexOf(current);
  return (
    <div className="lpc-stepper" data-testid="stepper">
      {steps.map((step, i) => (
        <div
          key={step}
          className={"lpc-step" + (i < idx ? " is-done" : i === idx ? " is-active" : "")}
        >
          <div className="lpc-step__bar" />
          <div className="lpc-step__label">{LABELS[step]}</div>
        </div>
      ))}
    </div>
  );
}
